// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRelated__box":"ns_a zu_pu zu_ko zu_kp"};